import { render, staticRenderFns } from "./NewDeal.vue?vue&type=template&id=6f2181ca&scoped=true"
import script from "./NewDeal.vue?vue&type=script&lang=js"
export * from "./NewDeal.vue?vue&type=script&lang=js"
import style0 from "./NewDeal.vue?vue&type=style&index=0&id=6f2181ca&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f2181ca",
  null
  
)

export default component.exports